/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Postgres RDS API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV7PostgresPaSqls10minByInstanceIdParams,
  GetV7PostgresPaTrendTopSqlByInstanceIdParams,
  GetV7PostgresSqlListByInstanceIdParams,
  GetV7PostgresSqlTextParams,
  GetV7PostgresSqlsByInstanceIdParams,
  MultiInstanceRequest,
  PostV7PostgresPaSlowQueriesParams,
  SlowQueriesV7Response,
  SqlDetailV7Response,
  SqlSortByResponse,
  SqlTextBySqlIdResponse,
  TopSqlSortByV7Response,
  TopSqlV7Response,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary PG > Multiview > Slow Query & 드래그시 SQL Elapsed List 팝업 내 엑셀 추출(isFullText=ture로 요청)
 */
export const postV7PostgresPaSlowQueries = (
  multiInstanceRequest: MaybeRef<MultiInstanceRequest>,
  params?: MaybeRef<PostV7PostgresPaSlowQueriesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiInstanceRequest = unref(multiInstanceRequest);
  params = unref(params);

  return customAxiosInstance<SlowQueriesV7Response>(
    {
      url: `/api/v7/postgres/pa/slow-queries`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiInstanceRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7PostgresPaSlowQueriesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7PostgresPaSlowQueries>>,
    TError,
    { data: BodyType<MultiInstanceRequest>; params?: PostV7PostgresPaSlowQueriesParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7PostgresPaSlowQueries>>,
  TError,
  { data: BodyType<MultiInstanceRequest>; params?: PostV7PostgresPaSlowQueriesParams },
  TContext
> => {
  const mutationKey = ['postV7PostgresPaSlowQueries'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7PostgresPaSlowQueries>>,
    { data: BodyType<MultiInstanceRequest>; params?: PostV7PostgresPaSlowQueriesParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV7PostgresPaSlowQueries(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7PostgresPaSlowQueriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7PostgresPaSlowQueries>>
>;
export type PostV7PostgresPaSlowQueriesMutationBody = BodyType<MultiInstanceRequest>;
export type PostV7PostgresPaSlowQueriesMutationError = ErrorType<unknown>;

/**
 * @summary PG > Multiview > Slow Query & 드래그시 SQL Elapsed List 팝업 내 엑셀 추출(isFullText=ture로 요청)
 */
export const usePostV7PostgresPaSlowQueries = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7PostgresPaSlowQueries>>,
      TError,
      { data: BodyType<MultiInstanceRequest>; params?: PostV7PostgresPaSlowQueriesParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7PostgresPaSlowQueries>>,
  TError,
  { data: BodyType<MultiInstanceRequest>; params?: PostV7PostgresPaSlowQueriesParams },
  TContext
> => {
  const mutationOptions = getPostV7PostgresPaSlowQueriesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary PA > Postgresql > Trend Analysis > 하단 그리드 > Top SQL 탭
 */
export const getV7PostgresPaTrendTopSqlByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaTrendTopSqlByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopSqlV7Response>(
    {
      url: `/api/v7/postgres/pa/trend/${instanceId}/top-sql`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaTrendTopSqlByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTrendTopSqlByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    'trend',
    instanceId,
    'top-sql',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaTrendTopSqlByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaTrendTopSqlByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaTrendTopSqlByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTrendTopSqlByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaTrendTopSqlByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaTrendTopSqlByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaTrendTopSqlByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaTrendTopSqlByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaTrendTopSqlByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaTrendTopSqlByInstanceId>>
>;
export type GetV7PostgresPaTrendTopSqlByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary PA > Postgresql > Trend Analysis > 하단 그리드 > Top SQL 탭
 */

export function useGetV7PostgresPaTrendTopSqlByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaTrendTopSqlByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaTrendTopSqlByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTrendTopSqlByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaTrendTopSqlByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql]: 싱글뷰 > 중앙 Check Point (sort: blkWriteTime), 하단 Additional Information 차트(sort: blkWriteTime)
 */
export const getV7PostgresPaSqls10minByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaSqls10minByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopSqlSortByV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/sqls-10min`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaSqls10minByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaSqls10minByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'sqls-10min',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaSqls10minByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaSqls10minByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaSqls10minByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaSqls10minByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaSqls10minByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaSqls10minByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaSqls10minByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaSqls10minByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaSqls10minByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaSqls10minByInstanceId>>
>;
export type GetV7PostgresPaSqls10minByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: 싱글뷰 > 중앙 Check Point (sort: blkWriteTime), 하단 Additional Information 차트(sort: blkWriteTime)
 */

export function useGetV7PostgresPaSqls10minByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaSqls10minByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaSqls10minByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaSqls10minByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaSqls10minByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * sqlId로 노말라이즈 쿼리텍스트를 조회하고, sqlId&sqlTextHashId로 리터럴 쿼리텍스트를 조회합니다. sqlTextHashId가 없으면 리터럴 쿼리텍스트는 조회하지 않습니다.
 * @summary PostgreSQL - 공통 쿼리텍스트 조회
 */
export const getV7PostgresSqlText = (
  params: MaybeRef<GetV7PostgresSqlTextParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlTextBySqlIdResponse>(
    { url: `/api/v7/postgres/sql-text`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7PostgresSqlTextQueryKey = (params?: MaybeRef<GetV7PostgresSqlTextParams>) => {
  return ['api', 'v7', 'postgres', 'sql-text', ...(params ? [params] : [])] as const;
};

export const getGetV7PostgresSqlTextQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresSqlText>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresSqlTextQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PostgresSqlText>>> = ({ signal }) =>
    getV7PostgresSqlText(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresSqlText>>,
    TError,
    TData
  >;
};

export type GetV7PostgresSqlTextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresSqlText>>
>;
export type GetV7PostgresSqlTextQueryError = ErrorType<unknown>;

/**
 * @summary PostgreSQL - 공통 쿼리텍스트 조회
 */

export function useGetV7PostgresSqlText<
  TData = Awaited<ReturnType<typeof getV7PostgresSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresSqlText>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresSqlTextQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > SQL 목록 탭
 */
export const getV7PostgresSqlListByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresSqlListByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<SqlSortByResponse>(
    {
      url: `/api/v7/postgres/${instanceId}/sql-list`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresSqlListByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresSqlListByInstanceIdParams>,
) => {
  return ['api', 'v7', 'postgres', instanceId, 'sql-list', ...(params ? [params] : [])] as const;
};

export const getGetV7PostgresSqlListByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresSqlListByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresSqlListByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresSqlListByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresSqlListByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PostgresSqlListByInstanceId>>> = ({
    signal,
  }) => getV7PostgresSqlListByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresSqlListByInstanceId>>, TError, TData>;
};

export type GetV7PostgresSqlListByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresSqlListByInstanceId>>
>;
export type GetV7PostgresSqlListByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > SQL 목록 탭
 */

export function useGetV7PostgresSqlListByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresSqlListByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresSqlListByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresSqlListByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresSqlListByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Postgresql: SQL 탭에서 연계되는 SQL 디테일 화면의 정보
 */
export const getV7PostgresSqlsByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresSqlsByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<SqlDetailV7Response>(
    { url: `/api/v7/postgres/${instanceId}/sqls`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7PostgresSqlsByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresSqlsByInstanceIdParams>,
) => {
  return ['api', 'v7', 'postgres', instanceId, 'sqls', ...(params ? [params] : [])] as const;
};

export const getGetV7PostgresSqlsByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresSqlsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresSqlsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresSqlsByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresSqlsByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PostgresSqlsByInstanceId>>> = ({
    signal,
  }) => getV7PostgresSqlsByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresSqlsByInstanceId>>, TError, TData>;
};

export type GetV7PostgresSqlsByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresSqlsByInstanceId>>
>;
export type GetV7PostgresSqlsByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Postgresql: SQL 탭에서 연계되는 SQL 디테일 화면의 정보
 */

export function useGetV7PostgresSqlsByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresSqlsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresSqlsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresSqlsByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresSqlsByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
